import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async pesquisarBairros(api, parametros) {    
    parametros.operacao = 'pesquisarBairros';    
  
    let retorno = {};

    await api.santriPOST('/rest/bairro', parametros, 10, true)
    .then(response => {
     retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
     retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  }
}


// WEBPACK FOOTER //
// ./src/components/Rest/RBairro.js